import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cpu, RefreshCw } from 'lucide-react';

// 🎯 شاشة مراقبة إنترنت الأشياء - رجعنا لعرض داشبورد ThingsBoard الحقيقي
// جوه iframe (بدل بودجتس Teknora المبنية من الـ telemetry API) - نفس فكرة
// إمبيد سوبرست بالظبط (Dashboard.js). لازم الداشبورد يتعمله "Make Public"
// من جوه ThingsBoard الأول (Dashboards > اختار الداشبورد > Make public) -
// من غير كده هيفتح شاشة Login بتاعت ThingsBoard جوه الفريم لأي حد مش
// عنده حساب شخصي هناك. رابط الدومين ومعرّف الداشبورد و الـ Public ID
// بييجوا من public/config.js (window.RUNTIME_ENV) عشان يبقوا قابلين
// للتغيير من غير إعادة بناء الفرونت إند.
const IoTMonitoring = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar' || i18n.language === 'ur';
  const [refreshKey, setRefreshKey] = React.useState(0);

  const runtimeEnv = window.RUNTIME_ENV || {};
  const TB_DOMAIN = runtimeEnv.THINGSBOARD_DOMAIN || '';
  const DASHBOARD_ID = runtimeEnv.THINGSBOARD_DASHBOARD_ID || '';
  const PUBLIC_ID = runtimeEnv.THINGSBOARD_PUBLIC_ID || '';

  const embedUrl = (TB_DOMAIN && DASHBOARD_ID && PUBLIC_ID)
    ? `${TB_DOMAIN.replace(/\/$/, '')}/dashboard/${DASHBOARD_ID}?publicId=${PUBLIC_ID}`
    : null;

  return (
    <div className="flex flex-col h-full p-2" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="bg-surface-card border border-line rounded-card shadow-card overflow-hidden flex flex-col flex-1">
        <div className="bg-primary-dark text-white px-3 py-1 flex justify-between items-center text-[11px] font-bold shrink-0">
          <div className="flex items-center gap-2">
            <Cpu size={14} />
            <span>{t('menu.iot')} — {t('menu.iot_monitoring')}</span>
          </div>
          <RefreshCw
            size={12}
            className={`cursor-pointer hover:rotate-180 transition-transform duration-500 ${isRTL ? 'rotate-180' : ''}`}
            onClick={() => setRefreshKey((k) => k + 1)}
          />
        </div>

        {/* 🎯 dir="ltr" مقصودة زي ما اتعمل بالظبط مع إمبيد سوبرست: واجهة ThingsBoard
            نفسها مش RTL-aware، وتوريث rtl من صفحة التطبيق بيقلب اتجاه أي سكرول
            أفقي جوه الفريم. */}
        <div dir="ltr" className="flex-1 w-full bg-surface-panel overflow-hidden">
          {embedUrl ? (
            <iframe
              key={refreshKey}
              src={embedUrl}
              title="ThingsBoard IoT Dashboard"
              className="w-full h-full border-none"
              style={{ direction: 'ltr' }}
              allow="fullscreen"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center gap-2 text-ink-secondary p-6 text-center">
              <Cpu size={28} className="opacity-30" />
              <span className="text-[12px] font-bold">
                {t('iot.not_configured', 'ThingsBoard dashboard is not configured yet.')}
              </span>
              <span className="text-[10px] opacity-70 font-mono" dir="ltr">
                THINGSBOARD_DOMAIN / THINGSBOARD_DASHBOARD_ID / THINGSBOARD_PUBLIC_ID — public/config.js
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IoTMonitoring;
